export default {
  'Jacob Bridgeman': {
    displayName: 'Jacob Bridgeman',
    logoUrl: 'flags/united_states.webp',
  },
  'Rico Hoey': {
    displayName: 'Rico Hoey',
    logoUrl: 'flags/philippines.webp',
  },
  'Ryan Fox': {
    displayName: 'Ryan Fox',
    logoUrl: 'flags/new_zealand.webp',
  },
  'Matthias Schmid': {
    displayName: 'Matthias Schmid',
    logoUrl: 'flags/germany.webp',
  },
  'Kurt Kitayama': {
    displayName: 'Kurt Kitayama',
    logoUrl: 'flags/united_states.webp',
  },
  'Mac Meissner': {
    displayName: 'Mac Meissner',
    logoUrl: 'flags/united_states.webp',
  },
  'Keith Mitchell': {
    displayName: 'Keith Mitchell',
    logoUrl: 'flags/united_states.webp',
  },
  'Michael Kim': {
    displayName: 'Michael Kim',
    logoUrl: 'flags/united_states.webp',
  },
  'Nicolai Hojgaard': {
    displayName: 'Nicolai Hojgaard',
    logoUrl: 'flags/denmark.webp',
  },
  'Harry Hall': {
    displayName: 'Harry Hall',
    logoUrl: 'flags/england.webp',
  },
  'Adam Scott': {
    displayName: 'Adam Scott',
    logoUrl: 'flags/australia.webp',
  },
  'Jordan Spieth': {
    displayName: 'Jordan Spieth',
    logoUrl: 'flags/united_states.webp',
  },
  'Stephan Jaeger': {
    displayName: 'Stephan Jaeger',
    logoUrl: 'flags/germany.webp',
  },
  'Xander Schauffele': {
    displayName: 'Xander Schauffele',
    logoUrl: 'flags/united_states.webp',
  },
  'Sepp Straka': {
    displayName: 'Sepp Straka',
    logoUrl: 'flags/austria.webp',
  },
  'Kevin Roy': {
    displayName: 'Kevin Roy',
    logoUrl: 'flags/united_states.webp',
  },
  'Jhonattan Vegas': {
    displayName: 'Jhonattan Vegas',
    logoUrl: 'flags/venezuela.webp',
  },
  'Kevin Yu': {
    displayName: 'Kevin Yu',
    logoUrl: 'flags/chinese_taipei.webp',
  },
  'Tom Kim': {
    displayName: 'Tom Kim',
    logoUrl: 'flags/south_korea.webp',
  },
  'Sam Burns': {
    displayName: 'Sam Burns',
    logoUrl: 'flags/united_states.webp',
  },
  'Nico Echavarria': {
    displayName: 'Nico Echavarria',
    logoUrl: 'flags/colombia.webp',
  },
  'Beau Hossler': {
    displayName: 'Beau Hossler',
    logoUrl: 'flags/united_states.webp',
  },
  'J.J. Spaun': {
    displayName: 'J.J. Spaun',
    logoUrl: 'flags/united_states.webp',
  },
  'Collin Morikawa': {
    displayName: 'Collin Morikawa',
    logoUrl: 'flags/united_states.webp',
  },
  'Patrick Cantlay': {
    displayName: 'Patrick Cantlay',
    logoUrl: 'flags/united_states.webp',
  },
  'Justin Thomas': {
    displayName: 'Justin Thomas',
    logoUrl: 'flags/united_states.webp',
  },
  'Doug Ghim': {
    displayName: 'Doug Ghim',
    logoUrl: 'flags/united_states.webp',
  },
  'Gary Woodland': {
    displayName: 'Gary Woodland',
    logoUrl: 'flags/united_states.webp',
  },
  'Cameron Young': {
    displayName: 'Cameron Young',
    logoUrl: 'flags/united_states.webp',
  },
  'Ben Griffin': {
    displayName: 'Ben Griffin',
    logoUrl: 'flags/united_states.webp',
  },
  'Rasmus Hojgaard': {
    displayName: 'Rasmus Hojgaard',
    logoUrl: 'flags/denmark.webp',
  },
  'Dan Brown': {
    displayName: 'Dan Brown',
    logoUrl: 'flags/england.webp',
  },
  'Francesco Molinari': {
    displayName: 'Francesco Molinari',
    logoUrl: 'flags/italy.webp',
  },
  'Stewart Cink': {
    displayName: 'Stewart Cink',
    logoUrl: 'flags/united_states.webp',
  },
  'Max Mcgreevy': {
    displayName: 'Max Mcgreevy',
    logoUrl: 'flags/united_states.webp',
  },
  'Justin Lower': {
    displayName: 'Justin Lower',
    logoUrl: 'flags/united_states.webp',
  },
  'Max Homa': {
    displayName: 'Max Homa',
    logoUrl: 'flags/united_states.webp',
  },
  'Sahith Theegala': {
    displayName: 'Sahith Theegala',
    logoUrl: 'flags/united_states.webp',
  },
  'Billy Horschel': {
    displayName: 'Billy Horschel',
    logoUrl: 'flags/united_states.webp',
  },
  'Victor Pérez': {
    displayName: 'Victor Pérez',
    logoUrl: 'flags/france.webp',
  },
  'Christiaan Bezuidenhout': {
    displayName: 'Christiaan Bezuidenhout',
    logoUrl: 'flags/south_africa.webp',
  },
  'Emiliano Grillo': {
    displayName: 'Emiliano Grillo',
    logoUrl: 'flags/argentina.webp',
  },
  'Alex Noren': {
    displayName: 'Alex Noren',
    logoUrl: 'flags/sweden.webp',
  },
  'Luke List': {
    displayName: 'Luke List',
    logoUrl: 'flags/united_states.webp',
  },
  'Maverick McNealy': {
    displayName: 'Maverick McNealy',
    logoUrl: 'flags/united_states.webp',
  },
  'Tom Hoge': {
    displayName: 'Tom Hoge',
    logoUrl: 'flags/united_states.webp',
  },
  'Tommy Fleetwood': {
    displayName: 'Tommy Fleetwood',
    logoUrl: 'flags/england.webp',
  },
  'Corey Conners': {
    displayName: 'Corey Conners',
    logoUrl: 'flags/canada.webp',
  },
  'Russell Henley': {
    displayName: 'Russell Henley',
    logoUrl: 'flags/united_states.webp',
  },
  'Keegan Bradley': {
    displayName: 'Keegan Bradley',
    logoUrl: 'flags/united_states.webp',
  },
  'Viktor Hovland': {
    displayName: 'Viktor Hovland',
    logoUrl: 'flags/norway.webp',
  },
  'Min Woo Lee': {
    displayName: 'Min Woo Lee',
    logoUrl: 'flags/australia.webp',
  },
  'Camilo Villegas': {
    displayName: 'Camilo Villegas',
    logoUrl: 'flags/colombia.webp',
  },
  'Seamus Power': {
    displayName: 'Seamus Power',
    logoUrl: 'flags/ireland.webp',
  },
  'Andrew Novak': {
    displayName: 'Andrew Novak',
    logoUrl: 'flags/united_states.webp',
  },
  'Scottie Scheffler': {
    displayName: 'Scottie Scheffler',
    logoUrl: 'flags/united_states.webp',
  },
  'Rory McIlroy': {
    displayName: 'Rory McIlroy',
    logoUrl: 'flags/ireland.webp',
  },
  'Robert MacIntyre': {
    displayName: 'Robert MacIntyre',
    logoUrl: 'flags/scotland.webp',
  },
  'Harris English': {
    displayName: 'Harris English',
    logoUrl: 'flags/united_states.webp',
  },
  'Ludvig Åberg': {
    displayName: 'Ludvig Åberg',
    logoUrl: 'flags/sweden.webp',
  },
  'Hideki Matsuyama': {
    displayName: 'Hideki Matsuyama',
    logoUrl: 'flags/japan.webp',
  },
  'Bryson DeChambeau': {
    displayName: 'Bryson DeChambeau',
    logoUrl: 'flags/united_states.webp',
  },
  'Matt Fitzpatrick': {
    displayName: 'Matt Fitzpatrick',
    logoUrl: 'flags/england.webp',
  },
  'Sungjae Im': {
    displayName: 'Sungjae Im',
    logoUrl: 'flags/south_korea.webp',
  },
  'Thomas Detry': {
    displayName: 'Thomas Detry',
    logoUrl: 'flags/belgium.webp',
  },
  'Antoine Rozner': {
    displayName: 'Antoine Rozner',
    logoUrl: 'flags/france.webp',
  },
  'Sami Valimaki': {
    displayName: 'Sami Valimaki',
    logoUrl: 'flags/finland.webp',
  },
  'Nick Hardy': {
    displayName: 'Nick Hardy',
    logoUrl: 'flags/united_states.webp',
  },
  'Adam Schenk': {
    displayName: 'Adam Schenk',
    logoUrl: 'flags/united_states.webp',
  },
  'Taylor Montgomery': {
    displayName: 'Taylor Montgomery',
    logoUrl: 'flags/united_states.webp',
  },
  'Isaiah Salinda': {
    displayName: 'Isaiah Salinda',
    logoUrl: 'flags/united_states.webp',
  },
  'Takumi Kanaya': {
    displayName: 'Takumi Kanaya',
    logoUrl: 'flags/japan.webp',
  },
  'Victor Perez': {
    displayName: 'Victor Perez',
    logoUrl: 'flags/france.webp',
  },
  'Noah Goodwin': {
    displayName: 'Noah Goodwin',
    logoUrl: 'flags/united_states.webp',
  },
  'Niklas Norgaard': {
    displayName: 'Niklas Norgaard',
    logoUrl: 'flags/denmark.webp',
  },
  'Michael Thorbjornsen': {
    displayName: 'Michael Thorbjornsen',
    logoUrl: 'flags/united_states.webp',
  },
  'Wyndham Clark': {
    displayName: 'Wyndham Clark',
    logoUrl: 'flags/united_states.webp',
  },
  'Thorbjorn Olesen': {
    displayName: 'Thorbjorn Olesen',
    logoUrl: 'flags/denmark.webp',
  },
  'Mark Hubbard': {
    displayName: 'Mark Hubbard',
    logoUrl: 'flags/united_states.webp',
  },
  'Ben Kohles': {
    displayName: 'Ben Kohles',
    logoUrl: 'flags/united_states.webp',
  },
  'David Lipsky': {
    displayName: 'David Lipsky',
    logoUrl: 'flags/united_states.webp',
  },
  'Ben Silverman': {
    displayName: 'Ben Silverman',
    logoUrl: 'flags/canada.webp',
  },
  'Garrick Higgo': {
    displayName: 'Garrick Higgo',
    logoUrl: 'flags/south_africa.webp',
  },
  'David Ford': {
    displayName: 'David Ford',
    logoUrl: 'flags/united_states.webp',
  },
  'Chandler Phillips': {
    displayName: 'Chandler Phillips',
    logoUrl: 'flags/united_states.webp',
  },
  'Greyson Sigg': {
    displayName: 'Greyson Sigg',
    logoUrl: 'flags/united_states.webp',
  },
  'Eric Cole': {
    displayName: 'Eric Cole',
    logoUrl: 'flags/united_states.webp',
  },
  'Pierceson Coody': {
    displayName: 'Pierceson Coody',
    logoUrl: 'flags/united_states.webp',
  },
  'Brandt Snedeker': {
    displayName: 'Brandt Snedeker',
    logoUrl: 'flags/united_states.webp',
  },
  'Mackenzie Hughes': {
    displayName: 'Mackenzie Hughes',
    logoUrl: 'flags/canada.webp',
  },
  'Steven Fisk': {
    displayName: 'Steven Fisk',
    logoUrl: 'flags/united_states.webp',
  },
  'Erik Van Rooyen': {
    displayName: 'Erik Van Rooyen',
    logoUrl: 'flags/south_africa.webp',
  },
  'Austin Eckroat': {
    displayName: 'Austin Eckroat',
    logoUrl: 'flags/united_states.webp',
  },
  'Ryo Hisatsune': {
    displayName: 'Ryo Hisatsune',
    logoUrl: 'flags/japan.webp',
  },
  'Sam Ryder': {
    displayName: 'Sam Ryder',
    logoUrl: 'flags/united_states.webp',
  },
  'Luke Clanton': {
    displayName: 'Luke Clanton',
    logoUrl: 'flags/united_states.webp',
  },
  'Jesper Svensson': {
    displayName: 'Jesper Svensson',
    logoUrl: 'flags/sweden.webp',
  },
  'Matt Wallace': {
    displayName: 'Matt Wallace',
    logoUrl: 'flags/united_kingdom.webp',
  },
  'William Mouw': {
    displayName: 'William Mouw',
    logoUrl: 'flags/united_states.webp',
  },
  'Vince Whaley': {
    displayName: 'Vince Whaley',
    logoUrl: 'flags/united_states.webp',
  },
  'Carson Young': {
    displayName: 'Carson Young',
    logoUrl: 'flags/united_states.webp',
  },
  'Kristoffer Ventura': {
    displayName: 'Kristoffer Ventura',
    logoUrl: 'flags/norway.webp',
  },
  'Ricky Castillo': {
    displayName: 'Ricky Castillo',
    logoUrl: 'flags/united_states.webp',
  },
  'Chad Ramey': {
    displayName: 'Chad Ramey',
    logoUrl: 'flags/united_states.webp',
  },
  'Matti Schmid': {
    displayName: 'Matti Schmid',
    logoUrl: 'flags/germany.webp',
  },
  'David Skinns': {
    displayName: 'David Skinns',
    logoUrl: 'flags/united_kingdom.webp',
  },
  'Patrick Fishburn': {
    displayName: 'Patrick Fishburn',
    logoUrl: 'flags/united_states.webp',
  },
  'Jackson Suber': {
    displayName: 'Jackson Suber',
    logoUrl: 'flags/united_states.webp',
  },
  'Lanto Griffin': {
    displayName: 'Lanto Griffin',
    logoUrl: 'flags/united_states.webp',
  },
  'Emilio Gonzalez': {
    displayName: 'Emilio Gonzalez',
    logoUrl: 'flags/mexico.webp',
  },
  'Si Woo Kim': {
    displayName: 'Si Woo Kim',
    logoUrl: 'flags/south_korea.webp',
  },
  'Nick Taylor': {
    displayName: 'Nick Taylor',
    logoUrl: 'flags/canada.webp',
  },
  'Johnny Keefer': {
    displayName: 'Johnny Keefer',
    logoUrl: 'flags/united_states.webp',
  },
  'Thomas Rosenmuller': {
    displayName: 'Thomas Rosenmuller',
    logoUrl: 'flags/germany.webp',
  },
  'Taylor Moore': {
    displayName: 'Taylor Moore',
    logoUrl: 'flags/united_states.webp',
  },
  'Lee Hodges': {
    displayName: 'Lee Hodges',
    logoUrl: 'flags/united_states.webp',
  },
  'Matt Kuchar': {
    displayName: 'Matt Kuchar',
    logoUrl: 'flags/united_states.webp',
  },
  'Patrick Rodgers': {
    displayName: 'Patrick Rodgers',
    logoUrl: 'flags/united_states.webp',
  },
  'Justin Rose': {
    displayName: 'Justin Rose',
    logoUrl: 'flags/england.webp',
  },
  'Aaron Rai': {
    displayName: 'Aaron Rai',
    logoUrl: 'flags/england.webp',
  },
  'Akshay Bhatia': {
    displayName: 'Akshay Bhatia',
    logoUrl: 'flags/united_states.webp',
  },
  'Christopher Gotterup': {
    displayName: 'Christopher Gotterup',
    logoUrl: 'flags/united_states.webp',
  },
  'Brian Harman': {
    displayName: 'Brian Harman',
    logoUrl: 'flags/united_states.webp',
  },
  'Chandler Blanchet': {
    displayName: 'Chandler Blanchet',
    logoUrl: 'flags/united_states.webp',
  },
  'Kristoffer Reitan': {
    displayName: 'Kristoffer Reitan',
    logoUrl: 'flags/norway.webp',
  },
  'Sam Stevens': {
    displayName: 'Sam Stevens',
    logoUrl: 'flags/united_states.webp',
  },
  'Alex Smalley': {
    displayName: 'Alex Smalley',
    logoUrl: 'flags/united_states.webp',
  },
  'Denny Mccarthy': {
    displayName: 'Denny Mccarthy',
    logoUrl: 'flags/united_states.webp',
  },
  'Denny McCarthy': {
    displayName: 'Denny McCarthy',
    logoUrl: 'flags/united_states.webp',
  },
  'Jake Knapp': {
    displayName: 'Jake Knapp',
    logoUrl: 'flags/united_states.webp',
  },
  'Bud Cauley': {
    displayName: 'Bud Cauley',
    logoUrl: 'flags/united_states.webp',
  },
  'J.j. Spaun': {
    displayName: 'J.j. Spaun',
    logoUrl: 'flags/united_states.webp',
  },
  'Taylor Pendrith': {
    displayName: 'Taylor Pendrith',
    logoUrl: 'flags/canada.webp',
  },
  'Maverick Mcnealy': {
    displayName: 'Maverick Mcnealy',
    logoUrl: 'flags/united_states.webp',
  },
  'Chris Gotterup': {
    displayName: 'Chris Gotterup',
    logoUrl: 'flags/united_states.webp',
  },
  'Robert Macintyre': {
    displayName: 'Robert Macintyre',
    logoUrl: 'flags/scotland.webp',
  },
  'Adam Svensson': {
    displayName: 'Adam Svensson',
    logoUrl: 'flags/canada.webp',
  },
  'Haotong Li': {
    displayName: 'Haotong Li',
    logoUrl: 'flags/china.webp',
  },
  'Jordan Smith': {
    displayName: 'Jordan Smith',
    logoUrl: 'flags/england.webp',
  },
  'John Parry': {
    displayName: 'John Parry',
    logoUrl: 'flags/england.webp',
  },
  'Neal Shipley': {
    displayName: 'Neal Shipley',
    logoUrl: 'flags/united_states.webp',
  },
  'Keita Nakajima': {
    displayName: 'Keita Nakajima',
    logoUrl: 'flags/japan.webp',
  },
  'Zac Blair': {
    displayName: 'Zac Blair',
    logoUrl: 'flags/united_states.webp',
  },
  'Daniel Berger': {
    displayName: 'Daniel Berger',
    logoUrl: 'flags/united_states.webp',
  },
  'Michael Brennan': {
    displayName: 'Michael Brennan',
    logoUrl: 'flags/united_states.webp',
  },
  'Webb Simpson': {
    displayName: 'Webb Simpson',
    logoUrl: 'flags/united_states.webp',
  },
  'Tony Finau': {
    displayName: 'Tony Finau',
    logoUrl: 'flags/united_states.webp',
  },
  'Chris Kirk': {
    displayName: 'Chris Kirk',
    logoUrl: 'flags/united_states.webp',
  },
  'Ryan Gerard': {
    displayName: 'Ryan Gerard',
    logoUrl: 'flags/united_states.webp',
  },
  'Matt Mccarty': {
    displayName: 'Matt Mccarty',
    logoUrl: 'flags/united_states.webp',
  },
  'Matt McCarty': {
    displayName: 'Matt McCarty',
    logoUrl: 'flags/united_states.webp',
  },
  'Adam Hadwin': {
    displayName: 'Adam Hadwin',
    logoUrl: 'flags/canada.webp',
  },
  'Seamus Power': {
    displayName: 'Seamus Power',
    logoUrl: 'flags/ireland.webp',
  },
  'Lucas Glover': {
    displayName: 'Lucas Glover',
    logoUrl: 'flags/united_states.webp',
  },
  'Luke Clanton': {
    displayName: 'Luke Clanton',
    logoUrl: 'flags/united_states.webp',
  },
  'Blades Brown': {
    displayName: 'Blades Brown',
    logoUrl: 'flags/united_states.webp',
  },
  'Kristoffer Reitan': {
    displayName: 'Kristoffer Reitan',
    logoUrl: 'flags/norway.webp',
  },
  'Rasmus Neergaard Petersen': {
    displayName: 'Rasmus Neergaard Petersen',
    logoUrl: 'flags/denmark.webp',
  },
  'Johnny Keefer': {
    displayName: 'Johnny Keefer',
    logoUrl: 'flags/united_states.webp',
  },
  'Daniel Brown': {
    displayName: 'Daniel Brown',
    logoUrl: 'flags/united_kingdom.webp',
  },
  'Jordan Smith': {
    displayName: 'Jordan Smith',
    logoUrl: 'flags/united_kingdom.webp',
  },
  'David Ford': {
    displayName: 'David Ford',
    logoUrl: 'flags/united_states.webp',
  },
  'David Puig': {
    displayName: 'David Puig',
    logoUrl: 'flags/spain.webp',
  },
  'Brooks Koepka': {
    displayName: 'Brooks Koepka',
    logoUrl: 'flags/united_states.webp',
  },
  'Cameron Smith': {
    displayName: 'Cameron Smith',
    logoUrl: 'flags/australia.webp',
  },
  'Joaquin Niemann': {
    displayName: 'Joaquin Niemann',
    logoUrl: 'flags/chile.webp',
  },
  'Patrick Reed': {
    displayName: 'Patrick Reed',
    logoUrl: 'flags/united_states.webp',
  },
  'Jon Rahm': {
    displayName: 'Jon Rahm',
    logoUrl: 'flags/spain.webp',
  },
  'Ludvig Aberg': {
    displayName: 'Ludvig Aberg',
    logoUrl: 'flags/sweden.webp',
  },
  'Rory Mcilroy': {
    displayName: 'Rory Mcilroy',
    logoUrl: 'flags/ireland.webp',
  },
  'Ben James': {
    displayName: 'Ben James',
    logoUrl: 'flags/united_states.webp',
  },
  'Andrew Putnam': {
    displayName: 'Andrew Putnam',
    logoUrl: 'flags/united_states.webp',
  },
  'Jayden Schaper': {
    displayName: 'Jayden Schaper',
    logoUrl: 'flags/south_africa.webp',
  },
  'Nathan Kimsey': {
    displayName: 'Nathan Kimsey',
    logoUrl: 'flags/england.webp',
  },
  'Carlos Ortiz': {
    displayName: 'Carlos Ortiz',
    logoUrl: 'flags/mexico.webp',
  },
  'Adrien Dumont De Chassart': {
    displayName: 'Adrien Dumont De Chassart',
    logoUrl: 'flags/belgium.webp',
  },
  'Laurie Canter': {
    displayName: 'Laurie Canter',
    logoUrl: 'flags/england.webp',
  },
  'Andy Sullivan': {
    displayName: 'Andy Sullivan',
    logoUrl: 'flags/england.webp',
  },
  'Matthew Jordan': {
    displayName: 'Matthew Jordan',
    logoUrl: 'flags/england.webp',
  },
  'Jj Spaun': {
    displayName: 'Jj Spaun',
    logoUrl: 'flags/united_states.webp',
  },
  'Lucas Herbert': {
    displayName: 'Lucas Herbert',
    logoUrl: 'flags/australia.webp',
  },
  'Bryson Dechambeau': {
    displayName: 'Bryson Dechambeau',
    logoUrl: 'flags/united_states.webp',
  },
  'Tyrrell Hatton': {
    displayName: 'Tyrrell Hatton',
    logoUrl: 'flags/england.webp',
  },
  'Jt Poston': {
    displayName: 'Jt Poston',
    logoUrl: 'flags/united_states.webp',
  },
  'Rickie Fowler': {
    displayName: 'Rickie Fowler',
    logoUrl: 'flags/united_states.webp',
  },
  'Alex Fitzpatrick': {
    displayName: 'Alex Fitzpatrick',
    logoUrl: 'flags/england.webp',
  },
  'Max Greyserman': {
    displayName: 'Max Greyserman',
    logoUrl: 'flags/united_states.webp',
  },
  'Jackson Koivun': {
    displayName: 'Jackson Koivun',
    logoUrl: 'flags/united_states.webp',
  },
  'Dustin Johnson': {
    displayName: 'Dustin Johnson',
    logoUrl: 'flags/united_states.webp',
  },
  'Sudarshan Yellamaraju': {
    displayName: 'Sudarshan Yellamaraju',
    logoUrl: 'flags/canada.webp',
  },
  'Jason Day': {
    displayName: 'Jason Day',
    logoUrl: 'flags/australia.webp',
  },
  'Davis Thompson': {
    displayName: 'Davis Thompson',
    logoUrl: 'flags/united_states.webp',
  },
  'Shane Lowry': {
    displayName: 'Shane Lowry',
    logoUrl: 'flags/ireland.webp',
  },
  'Minwoo Lee': {
    displayName: 'Minwoo Lee',
    logoUrl: 'flags/australia.webp',
  },
  'Martin Couvra': {
    displayName: 'Martin Couvra',
    logoUrl: 'flags/france.webp',
  },
  'Angel Ayora': {
    displayName: 'Angel Ayora',
    logoUrl: 'flags/spain.webp',
  },
  'Mikael Lindberg': {
    displayName: 'Mikael Lindberg',
    logoUrl: 'flags/sweden.webp',
  },
  'Marco Penge': {
    displayName: 'Marco Penge',
    logoUrl: 'flags/england.webp',
  },
  'Scott Jamieson': {
    displayName: 'Scott Jamieson',
    logoUrl: 'flags/scotland.webp',
  },
  'Padraig Harrington': {
    displayName: 'Padraig Harrington',
    logoUrl: 'flags/ireland.webp',
  },
  'Casey Jarvis': {
    displayName: 'Casey Jarvis',
    logoUrl: 'flags/south_africa.webp',
  },
  'Bernd Wiesberger': {
    displayName: 'Bernd Wiesberger',
    logoUrl: 'flags/austria.webp',
  },
  'Grant Forrest': {
    displayName: 'Grant Forrest',
    logoUrl: 'flags/scotland.webp',
  },
  'Ewen Ferguson': {
    displayName: 'Ewen Ferguson',
    logoUrl: 'flags/scotland.webp',
  },
  'Daniel Hillier': {
    displayName: 'Daniel Hillier',
    logoUrl: 'flags/new_zealand.webp',
  },
  'Aldrich Potgieter': {
    displayName: 'Aldrich Potgieter',
    logoUrl: 'flags/south_africa.webp',
  },
  'Eugenio Chacarra': {
    displayName: 'Eugenio Chacarra',
    logoUrl: 'flags/spain.webp',
  },
  'Tom Mckibbin': {
    displayName: 'Tom Mckibbin',
    logoUrl: 'flags/northern_ireland.webp',
  },
  'Alejandro Del Rey': {
    displayName: 'Alejandro Del Rey',
    logoUrl: 'flags/spain.webp',
  },
  'Hennie Du Plessis': {
    displayName: 'Hennie Du Plessis',
    logoUrl: 'flags/south_africa.webp',
  },
  'Danny Willett': {
    displayName: 'Danny Willett',
    logoUrl: 'flags/england.webp',
  },
  'Joe Highsmith': {
    displayName: 'Joe Highsmith',
    logoUrl: 'flags/united_states.webp',
  },
  'Kota Kaneko': {
    displayName: 'Kota Kaneko',
    logoUrl: 'flags/japan.webp',
  },
  'Connor Syme': {
    displayName: 'Connor Syme',
    logoUrl: 'flags/scotland.webp',
  },
  'Calum Hill': {
    displayName: 'Calum Hill',
    logoUrl: 'flags/scotland.webp',
  },
  'Marcus Armitage': {
    displayName: 'Marcus Armitage',
    logoUrl: 'flags/england.webp',
  },
  'Oliver Lindell': {
    displayName: 'Oliver Lindell',
    logoUrl: 'flags/finland.webp',
  },
  'Darius Van Driel': {
    displayName: 'Darius Van Driel',
    logoUrl: 'flags/netherlands.webp',
  },
  'Guido Migliozzi': {
    displayName: 'Guido Migliozzi',
    logoUrl: 'flags/italy.webp',
  },
  'Karl Vilips': {
    displayName: 'Karl Vilips',
    logoUrl: 'flags/australia.webp',
  },
  'Zach Bauchou': {
    displayName: 'Zach Bauchou',
    logoUrl: 'flags/united_states.webp',
  },
  'Rasmus Højgaard': {
    displayName: 'Rasmus Højgaard',
    logoUrl: 'flags/denmark.webp',
  },
  'Aaron Wise': {
    displayName: 'Aaron Wise',
    logoUrl: 'flags/united_states.webp',
  },
  'Austin Smotherman': {
    displayName: 'Austin Smotherman',
    logoUrl: 'flags/united_states.webp',
  },
  'Zecheng Dou': {
    displayName: 'Zecheng Dou',
    logoUrl: 'flags/china.webp',
  },
  'Preston Stout': {
    displayName: 'Preston Stout',
    logoUrl: 'flags/united_states.webp',
  },
  'Gordon Sargent': {
    displayName: 'Gordon Sargent',
    logoUrl: 'flags/united_states.webp',
  },
  'J.T. Poston': {
    displayName: 'J.T. Poston',
    logoUrl: 'flags/united_states.webp',
  },
  'Davis Riley': {
    displayName: 'Davis Riley',
    logoUrl: 'flags/united_states.webp',
  },
  'J.t. Poston': {
    displayName: 'J.t. Poston',
    logoUrl: 'flags/united_states.webp',
  },
};
